import React from 'react';

export function CashFilters(props: {
  date: string;
  posId: string;
  onChangeDate: (v: string) => void;
  onChangePosId: (v: string) => void;
}) {
  return (
    <div className="card">
      <div className="card-body">
        <div className="row g-3 align-items-end">
          <div className="col-12 col-md-4 col-lg-3">
            <label className="form-label">Data</label>
            <input
              className="form-control"
              type="date"
              value={props.date}
              onChange={(e) => props.onChangeDate(e.target.value)}
            />
          </div>

          <div className="col-12 col-md-4 col-lg-3">
            <label className="form-label">POS ID (opzionale)</label>
            <input
              className="form-control"
              type="text"
              placeholder="es. 1"
              value={props.posId}
              onChange={(e) => props.onChangePosId(e.target.value)}
            />
          </div>

          <div className="col-12 col-md-4 col-lg-6">
            <div className="small text-muted">
              Se POS ID è vuoto, vedi il riepilogo di tutti i POS.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}